<template>
  <div id="main_content">
    <div style="display: none;">{{ country }}</div>
    <!-- <span>{{amounAAAtList}}</span> -->
      <!--   支付方式   -->
      <div class="method"  >
        <div class="contentTitle">{{ $t('center.method') }}</div>
        <div>
          <ul class="methodList" ref="methodBox">
            <li v-for="(methodDataItem, index) in payMethodJson"
                :class="['methodItem', index===activeMethod?'pay_method_active':'']"
                :key="methodDataItem.name"
                @click="changeMethodToPay(index, methodDataItem.payment_method)">
              <div class="methodImg">
                <img :src="methodDataItem.cover"
                     :alt="methodDataItem.name">
              </div>
              <p class="methodPay">{{methodDataItem.name}}</p>
            </li>
          </ul>
        </div>
      </div>

      <!--   选择商品类型   -->
      <div class="goods_type">
        <div class="contentAmountTitle">{{$t('center.SelectItem')}}</div>
        <div class="tabAndPoint">
          <div class="SelectBundle">
            <div v-for="(item,index) in amountListName" :key="index" :class="['item', index===nameIndex?'itemActive':'']" @click="tabNameSelect(index)">
              <span>{{ $t(item) }}</span>
            </div>
          </div>
        </div>
        <!-- 特惠 -->
        <!-- <ul v-if="nameIndex===0" class="goodsList preferenceStyle">
          <li :class="['goodsItem', index===activeGoods?'goods_active_item':'']"
              v-for="(goodsDataItem, index) in amountList"
              @click="changeActiveItem(index)"
              v-show="!goodsDataItem.disabled"
              :key="index"
              style="padding: 0!important;">
              <div v-if="goodsDataItem?.countDown" class="goodsTime">
                <p>{{endListTime[index]}}</p>
              </div>
              <div class="goods-img">
                <img :src="goodsDataItem.goodCover" @load="countItDown(index, goodsDataItem?.countDown)"
                   :alt="goodsDataItem.goodTitle">
              </div>
              <div class="goodsBtn BtnName">
                <div class="price onlyPrice" @click="payNow(goodsDataItem)">
                  {{ goodsDataItem.currency?goodsDataItem.currency:"USD" }} {{goodsDataItem.price}} 
                </div>
              </div>
          </li>
        </ul> -->
        <!-- <ul v-else class="goodsList"> -->
        <!-- <ul  v-if="!isSandbox || nameIndex!==0" class="goodsList">
          <li :class="['goodsItem', index===activeGoods?'goods_active_item':'']"
              v-for="(goodsDataItem, index) in amountList"
              @click="changeActiveItem(index)"
              v-show="!goodsDataItem.disabled"
              :key="index">
            <span class="endShowTime" v-if="goodsDataItem?.countDown">{{ goodsDataItem?.countDown ? endListTime[index] : "" }}</span>
            <div class="goodsCorner" :style="{'display': goodsDataItem.goodCorner?'block':'none'}"> {{goodsDataItem.goodCorner}} </div>
            <div class="goodsImage">
            <img class="scaled-img" :src="goodsDataItem.goodCover"
                   :alt="goodsDataItem.goodTitle">
            <div class="goodTitle goodTitle2">{{goodsDataItem.goodTitle}}</div>
          </div>
            <div class="goodsPack" :style="{'display': goodsDataItem.goodsPackDetail.length?'flex':'none'}">
              <div class="goodsPackDetail"
                   v-for="detailItemData in goodsDataItem.goodsPackDetail"
                   :key="detailItemData.cover">
                <img :src="detailItemData.cover"
                     alt="icon"
                     width="28"
                     height="28"
                     @load="countItDown(index, goodsDataItem?.countDown)">
                <span :style="productStyleItems(`${detailItemData.count}`.length)">×{{detailItemData.count}}</span>
                <span>{{}}</span>
              </div>
            </div>
            <div class="goodsPack" v-if="goodsDataItem.goodsPackDetail.length == 0" style="display: block; visibility: hidden; height: 32px"/>
            <div class="goodsText" :style="{'display': goodsDataItem.bonus?'flex':'none'}">
              <span>Bonus:&nbsp;</span>
              <span>
                <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAG0AAABnCAYAAAAKY8wwAAAgAElEQVR4nOV9aZBdx3Xe132Xt8/Mmx07QIIgABJcIIoESXG1SXATJdGMJEeOJceJlEpVqvIjyY/8if8kZVe5HJedVU4pdsmOy5LlSBZNyyIlhqQkC+JiEgQIYLANMABmX96+3KVTvdz3ehr3vXkzAEUm7qk777777tpfn3O+c/p0X/IdvIuPWmEAARgFwBeLfzK5Hn3PEGAQIIME6CcEA6BkgBAMgiJPCBkARR8hyIAgDUJyhCIrjidwQJAEEDKfvRdUw/8dhuwFAjIpL7262HDQRAP/Gr+CMzj+kagp+yNwD6IwwAUwDGBUfpIRAENq2zCR6/y3vJ2gSaffdpwctZ2sZYvPnGU7fZbDv9s5y7Yz1LaT1LJSFHyxU5aAnFqAZVMwm6G01Hzk0reXDsy9XPrF0MNvEeAnH4GqWLN86KAx4GMM7NMUeMDts/vcQTvp9tsJd8BKuAPi03XzVsLptxOJvA2734KVJKCOXIhNQC0CaqvvlICGBKShlpDLFAAPQBVATa1bQN+eFPL/PjV8Yf/Ss5P/YzHdLPi/QUB+fPVdkg+jajqWDw20ENjPED6dHnf/wZbPDewb3pvN2jaFlZSSYaWIWKcJte5SqRh5aajKr6v1qlr4elOB4mnrAQBfLZ76ZPIc6Qdd7P7KCMIm+4Wz/3l+CSEuAbgAARVBCmlYsEGFZv5olJ87aCHYzhDs6dSQ89nNvzR0YPzZXD5/TxoutYHLAEqqUpsKiCUNHE/7LQ4MT7NKRC26lSLKKiaU9M0CeAtw7rGw81ODpHyy/tj0S8XDFOSrDlwUsIQ/wG+hhAKmMfX3D7QQbDxE+HSy3/n02NN9d48/0zc6/EgWiXF1C+cAcMV0BYCjARKoCg7UiaKKJ5rW0sHQQWPapw5etM7PXwZwAshsSWDLowMD8z8uPx1Uwz91kSg5cPDX+AZ80Ro+OuUDBy0EGwk4WFn3sdHHso+OPpkbH30yh9RWZ/WOOSVVHLx+jSdaCsSEBoZeou9sjd/17aE6f1M1hoI8PjeUJvlb07cXftY8tIjZl/4C/1Owx783oIVgwwHCx1Jp55HBB/qeG30iN7TpM/1I7XDiD+AcsU8B5BjqTZcyW23TTQyJAS3UzhGqbXFS2JSLNw1YAw7GD/WNVn9W/PwCZl/6M3z1g6iaay7XHbQQbChEeCiRch4fviP7pbHD2b4tX8gjvdvtfiBR0uQYgEADTleNccDBACQqVANMB85WgPpAswCEFkVuazrl5qv302W6JYnU5bpgPB+tct1Ak2Cx2xJJ65ns3vQ/G30sl97+j/LIHEi0dzIr0yxc0lJaper2SJcaYgAXpxL1fU0yom9T+4Q1oHQWsLe7GLs3O3jsxeCJOmpfi3O4P+xyzaCFYAMMbK+dsJ7r2+n+i7HDueT2Xx1E7raklBqmKoYZkhJXuIrMKjof3ZlJIKLzWa0bWH1OHRRrjSonioxQuVtxkiEzZGHwtsxQ5vvZZ2709//pJE5VAwT6HX/oIF4TaAxsJ7XJP09tSfzLsadyzo5/mkf//nS7EiOaHl3JWUPStirgLmu2S6+iUAODaAs0qTJBZDEqUz+nL7cTC2jOeWDTQGobpTdtu+nj/+r8b+35N/jCuyUU9bs0n+DnDuKGQWNgNzsZ6zc3Pd//yR1fGbQGDqZBE0Q+QuT8Bhr7ozGVZ5ZNAAYA4d5aMaB1Ih8wzqkfR43tOrmhqlERgLpA2AhQOOtjYCiNsbv78+cvZp+zA/eUehqqnUUv5p184GVDbj4Dy1OHfmnLPxx49sDvb7EG781IwHgrLyoKXdcqLZKAcI0T9wEsBzAVLhaLpRZtHep7S+J0kJh2rci/09lnaICnjrFsualwuYHqUoj+Xel0KpH64h24b9gWre4qBWwC99EGzUe4N3tT4tM7vzxE7Zw6ReTvlNutV8bnu7TRmEKodozuRGvbwmjd1tSu1cW2sQ6NJvrdl6DZSYZ6wcPKRR/JkGLrnvHh5+mvH+xD3u1iPbuB+YGUdYMWgo0mkvbzI49l9/QfTLXBqCglEmpOMdGu0I2A6EX5aaECh0tWyBdbLpGEMbv9O1PfV3XeUKNaOy2QDY5H/2kSCBoBSpc9FJYpNt8+6GxObH7GgjNgcNg4wBCz/tEALUD4QG5/8ovbfjXfjqHWVZzQN6QkTlLWeqS8VJPiMEtrAFYbrNZ3uvrcLQAtDTwrBkz9vlTjojwe7TKwIERt2Ud5gaBvJO2kM8mnn8Rnt/SJG7sKLHwYwK0LNAY26qbtx0cezw7136mkrKkkzDceiRqV2qvyGAfYiLRroJrtihZbAteye5Za1+2gZg+jY1qSbxkAKsJDbIAmGBgLEDR91OYCNEsUo3vy44+6T93Xj8E+TUXGyTF+XsCtCzQf4S8MHEg9s+XzA217EHWH4OqW36okax2PMAawQWWCNOJxlQRHatIyyIqqwgg46OCb92dpLNUGrCQ/niEIQlQWAtQWCcb3D2AoOfysB39cNU3zbn7uwPUMGgNG3Iz91Mjh3Ob+25WURX1WvnaLJEYVUe33tUpWBY9JWxW2JEeXJlsDRgfB1kAkyh5qwDENNKbfWwSa+vNrIapLQCqZJrnBzKFHyTM3DWA4isVRo+46qcxen3pdpWfQAoRPDH4s/dDm5/vlhlDr5wq0Hc1KJNr2XooCK2SK9BG1mMBpalffzu0gsVZLIj82oG3CEmoMlKloCCc/EjTpJ3DbVp0HqgsEwzf19X06/YVPDGFs1FCRceB94KWnqmTAoJO2Pjn2VN+2vgNJ+ZRNBZouZab9WY9a1J9c+Vcs1PwqrFZEhEj3gNDVqpBpKUFEJxua9Ld+p6vVI0ky5coxBCyAV+JqEhjZ1Y/BTP7ZfgzuaicrdLRtH7ia7Am0AOGnh+/L3D32VE5u8BVbjLNlug1CjOLo5aY28cAtYPGKDSSIRHWGMs2RFqtEXUIByZRk6oRESB9VdlLtF4EngFduCkvx80v1yJ86CEM0VnjGURK54fT++6xHbxnCaBTSjrO0cewyKtcNuDVB432DTop+ZuzZvh25SMpqWoKMHgimBlPboLtJ9gLWYcC6HSB7ADIKEGVNhNoMAZ8BgVrCaInwVKCFSm0KvGmbZYYaWRFkJ5I0N7pdJgkJ81ErAYVpIL83g8f6n7l/M3beYDg33TzAD4eIhAg/O/pI7vaRR7JyQ9OQMp182KvV0IZvOZC91+QQYN8H2LcC9o0A3QmQLZJdklTbHoWkLUUCOCWRq7rQtKpsSaPBMnlml0Vk/JRLXMhCNGo+agvAwGgOQ/2DDw5h/CYHbpxd68V/uy5lrYBxznbpL296rn9b7takrEwz8gFDLV5rUIef9wyAU+q8KcUmbwCsNGDxxrIAsAXAqwJMJfSwJsBUkg8HjSg1qnebiVul7e2t2LXaSaTl2ZboiAmEkgzFSb2yjaDkIj2S3v7k5eduu9Q8++MzOO5rNRD3FFGJC2tfU4C5K2gM7LPjT/TvH3wgIzdUtWwpS5MuW1OLGyQfrTIN4G0A59V5eFgro4BLAyI3OAOQccDNKtBWgLAA+BWpATh4TEuXI5rIcTVKtZ6GVu1RCZptE/h+KMiIhC1EoxqgdImi/8YU7pz52AMjFze/egbH34JMsGVY3QZIDDgkBrwNA9cRNAYMWQ79tS2fHxjP7E5IdVg01KIOln0d1CJ/jLMKsKZqrzV13Vl17gjEjASRJCSQ1gBANyvVWgTCMuArSWSBBJD48pyh+uRgkkgaOZguhZ20QMoBKIeMhfBBUGkGGChYGL49i0p+9BODF0fvIqBHGMKUAZr+JDDAu27AxYImc+nx7NgzfXvzh9JEUOOyUo2B1j+mObSrbNtGVSPPxDqtdevASOyJSFBJqwZXSWAOIJl2wNnKAXRQHVsHgioPBisWGqlTTwMzAi1rISz6YCGR0RjG3YAAxTpDbt6CO247z0w+v/dy4fzWd/CTZfXEcdIGoxbiANoQcB0kjW2209aXt/1qPp/a7rTVYlMDyzHo/XojH3HlrFKPVFW22U+GdiJOy2qYkugqO9inQFRdNzbvUB9WvpmrpI+DWAPYrLyeBQI3QVtqkf8XfhsLUaoxNC4R5PcncMelOw9uKuy47R385AcxKjLKXOmUoYJrUY2IA42BUQIcHn0id0v+42lKLNLuJ4OW4mZG2q+B4otyTiVjN7S2q6e+RdIWxigi3QlvqHtd0GxuWrJRmlMZXymAROvKPvLwWeKyjb5dacxN1QVQUUiL038SBKgXCfJ9KQyM5Pbuwp6DAxj64QoW9bvtRv9hqM1O9m7NEkf5d9g568vbf30w7Y7ZUsKKqnXbql3p6QPdSO96yoSSFhOYuB5pc5v++KGWOl5TAC4CuCgzifG+YqYXVDYzX+Zlo0jsIRh70EUib0k/Tjna/JPCR63GUJumSI45ifvHHrrtVnz8xg5hrbXAM8u6am0VaELKCOFSdjB/d9ri3RUi67emqR7TF4uLgqy3nNGkDIZahKEqdTWpg8gM8PR7DI2BGtxmLqsEolOK+BSl9A0fdDG6PwNKpD2TilKqykodqF0E+rcncOtN++8Yw7a7YsJa3bpu9GJu6xk4AzTsdgasL+348qDl5OlqtZgwQDP7pDYKGK/Ad5SUmZITfQ80gGAA1UuJqi3SFJaq6pJ6vrS8//pRhkYpxK7DWbh9VEZK1AV9MHiBj0qRwU266N+U2Xyzdeud23BDuoPOiauRjdZS/ElCwKaUPDV6OHd3/p4M5cN8hNpoqAdNxIRJdSnbaDmlyIengREai15Cw9ZhDfBM6YvscRT0Tss+vPqKj1PfXMC57y1jaFsCW+/LABaThEUoyQCU+ChVGOozQHac4hPbHz5wFx7cr86mB+/MyGsnqduQMdGQZzcnRu1f3vGVQdhZKtViWZ02YSTPmKBttHBJfk+pKh0AU8LiknNMoOK8JP17FO2Pci+jrqV+mWu5dKWGiSOXce57C5g5UsENT2SR2+wiDKVN42LH1aTfYKhNAZlNLm7Yv23PKLY+pOA3pS1OVZouwYaKAC0Ec6lFPjnyaPZu7peJB1pRl0gZalHv7rCvQeCZIgVzmiMNQ0WaYMW5AIgB3FyHJgu6jeMAbgGaTR+zR0uoLdWxNFXC8ZevILRCbHs4DTsFBH4UHeEskmFlmbcnG4NbU/ndyb0f3439eXWVOFvWTeqwEQCpfB62L73V+QyXMiuhbJmvAEtp0kQM0DYqZUwRnPeVtEWABF0IRhxg3UCKe9LIwYlAGwOwHbhyuoQzR2bg10MR41o+V8fk9wvY/AkHAzcmZPgrVC4ACVArM9SngNQowaF9h7Z/Ak/eo0lRnJSZ0tap9AQgDcEyNqWfGX40e/fg/SrGGGVBR/RelzLLiIJspHD79WabarfUVTdGGBcs0hsBtDYdt1/0W6hdcxPglQNM/2wFy1NF+F4IyyGoFRs4+6MZ1GZ87PyFHJIDNkJPylrAQ8k1hsplwO53sH3f2PYxbLk/gWScExQHWpxuWh/lD7mU7U58cvuvD0I40k31wHaM+jP7zDZSmFK9Z1VYTM8CDg0ywox1HaS4wFGcLTMB9ZWU8WxmFzj9ygzOvH4J8BiIoot8fHdp2sN7fzmP3G0MwwcSIDYVajLgli0IUV7kI20o+sfd5C19B+64D4+Px5ARaqhBc70XV+Bq0ByHPj/ySPaO/L1Kyhrq0ia9j4s1bqRwcvO6iljoA9fjKjvQfDTEABd3TCflw7Tr8UawGZi5UsWZv51Heb4uu3Mo91SZeD4eEZk7XsTK2wF2PZBEbrOFwAtEEJmTk3oZqE4ByX6CWw7u3X4n7n04BrD1+G09F5rbm3xm2xfzlOjm0o4hH2YC6EbLopKymiFBcT6Z+VsncDqNETBBVsFi0UOQAi6+fwXTpxdAAtkrSkICyqMfPHhsU9SLId5/YRbWphCjB9JwEpZIr+M92qzGu2sAz7WxY9/Y6Bi2POsiYceow24EpBMh6QoqTW539w7craV328ZoTL1H2u7WmdND4eTjiJI2ZqjCtWwZiZG4bmwyLnISxS9HgIsXCrh4fAHNYgMsZKCEqZrmk/ow2ESSjuWpCi79sI6tH3cwsNuC3wyFZQubTCT9NOcIUjlC9+3Yt/WT+JU9vBtVq7m1QlsbKpTYsIQt0zGmmsRFP10rxedlRoWMvBj7FeeTdSIiusOsF3Mf/RrRTAkZacsmj1/B/PklOVFMK9mHCcAIkye2LXncuR8sANTHplsySOZseEGAgDH4ZaB+jrtwBHvu3Jm/A4ceUtmaMFRlr9LWU6FXqZa4uOK1kg8otfiOkjI/Rqo6UftOv8HYBwZQJrmJetv7gDNnZ3Hx5DSa5TpvthAdhqpDVNSgyPAiYsIXLoGVlQZO/3UR+Tsohm5zEdQBPwzRrDFUL/MUCAtjOwdyY/amR3fipnQHsNYbj+wI5Gq56RRB023bRkpThavOaICFXSSsk5SZYJldN52WSLLTQK3JcOrtC1iYWhGgEO3hBUxEUUCFHhHzaVFMvVlCdd7DppsTyA7bwiFnPkOpCJTmgIxFyY037dr5i+Qztzlw3dZJe+8B6Ll2r1Z2pvN8PaRsVklZTQMtzpGOylosME6i4iaLCbSZfBwJ2qmTU7hyZg5+zReQCWXCGCyuGkWCKwUhZNVNEMLgBz7OvlBEenOIsbtcYdM4kwyawPIloOEBu+/YmrsVdz0eIIjGs5kDvtADSGtKW7yFup4Uv6IiH1MxKktXzWttYx1A0pdAo/X6tSyZjlBqejg5cQaFpeJqGSORCPA/S6nHaCFC+myLYP5MGYuTTQzd4KB/u4WG74v0BZ7QWqtQjIxm3LHc2N0HcPewDTtOZ12LvmqVzpKmq8ZruQwfP/1uhymT0EENxqlPHQQTLF87f2CATFRQuA84dmYSCzOLQq0R7aHkuAAudVZbfxEivkXrlH93GC68VIFtBdh6lwOea+fzGEkdqM/JjNgb9m3b/Cn6hY+7SKa6dJBek98WDxrtEBFZbymrHuk5o0JNgEygzCUwHHHPkDiT9uvugSMH3680qzhx7CQqy1VQqqSJpxGQNvHgzJEq/4K06oKJXEm+2BZFeaGMudMVZEcsDN1ko9kIEXhAeR6oN4Btt44kd9o3PZNAyhzPtpaj3cln6wE0aF0Y1yplvHv/7zRQfK0yO6m8MEb1ecasc2ZoKy6cFf2WA8IEw9H3z6MwXwCCsCU94o+odTEoQNLHaBs/CaUy65gn/XCFl0hauPTjGuqVJsYPUvF7EEj671d5DknGGh8cu+d2cs82G44dA1A3MhJXrtoeL2nXmnAKJWVnVbgq1CRClyo/BrTAAMo37Fov9D9aElI1rtTKOHnsFDwvgO04rZ2jwRuUEakCFeJEnZhSSVTkCB0mSIpFKPyGh7kTdUFeRm+14HsMfhMoLfCEWYZtB0btZ+0v3J/DwIA2+UUn+9ZJ2jqW7kTkWsoppRpDQ42tRSaaMW6BLpVxJY55UmnHGk6At06cwcpSAW7SRrIvCZt3P0EGiLmt4mBQRTgi8iHVI1NDcdp6lwPpJChmj9dQLNcwdpAg4VABGs/5r9UINu/KOztSOx/uw+AQkfnNndRjHHBoXWz1euv7tUJzdYkGaGyR+ffiCg3Nl4oDqal9XyukhRiQTJVIlHrPAkvVEk4ePYVmtSECvsl+lw+ARzLrCMBEzJGEIk0ujHRjCzgihz1RuV2EuiiBbdniseaPBWiuMGw6CIQe4FWAWhnI0iRGRoYOPEyevjGDPreDv7bh8Nb1A42pRBk+295vKCl7AMDtWqejOVVt07BRcY51HDhx4Sti/N4PVGkD7xybQHGuCPgEXtVHea4iCMjg1j5khzOiOypkKnwFXagkkPKUasyaSDsIQGgIN2mheLGO5dkK8nuBdD8Q1oHqLFBcAjbtyzsPZR57aABDY2vM+9CJlHQs12cWOn5L3wXwqop6RNMsfQHAo0ryjmgVato4YnzqpVfbqh/nStAWamWcOD4B3/dh8Tgu4yNtPBTnaiCei9xgFimXobHkg4S0VVtR4DiycQIsEhknGTnhE1xbNsPiaQ+5Ph9bD9k49ypQXgDSOWB0Wz92pnZ+KlceeAHAJNrTu+nAhTHSRQydwczfrl3SfqYk60+UP+apSuMk5FuKiBwGcMBggSb7g3GrcWDFqUfzdyonhi/aVbxz7CTKiwUx0pNSSTZE5TcCVBdqqMzVwQhBasCFk5JAEDn0ovUnbV0EKFNERWpM16WoLflYuFRDYgToH5GjdcorAFlxMLAll3na/dzeMWwdMACLCxjGgRdbNg4aj9b/NhD+VyD8kcqoShopCicVcDx94WmlKmH4a4hRh53CWL1IXVrO3j9XKeHEexMIfW6HaMuZ5qDYlIoQVG2ljupSHX4jFHP1u3x2ckddmsjovQ6UcA2IdBMsIkNfPMq4ctHD/NkGxu8B3CTQWAaKC8Dg7izu73v4UB4jW2NmWtmoeiTrB41H6/8I8H8XaP4VwM6o4UZ6XiTRUu64r/YdpTKfVRJH10ji6VTilIb+SWU63LJfxtF3TqG6VG6NTVO9LYraS9UnhujWAzTKPrymcgH4MF5ndYNvA84lzJIERgBHkEhQhNUQS5MN8bwDm+TonEYBGOrLYiw7cmgbbrzBghPHItfTWdqqod5B4zHEFwHvd4D61wHviDpVSpuEzBwgH2Xz8rd9/KVSjc8A2Ke2B5pWRwf1uJbU6QDywNEgcHl2ASfePiUAo2hLGdWCV62glcrZ95uByMbieSBCTfKXM9AwQlqrSdmHIySOcr/NQippob4YYvZkE0O3yMGOzRJQW7KQ25rpezT7xG1bsHPYiJCYtN98MnO9VXoD7SdA8/eB0n9hqL7I0GxINWRZUrdf5S7qznmUHPqeAi5UwO1ew/dabyEy72O5WcLxd86iXqqIG+EVK6SLkRaNb3tjMowlMA9DhHwEqBcKldpuKPIm2Sraqs4hIs1EOOzEJ1iaasLzgJEbgQoBSlPA0N4M7h67974RbN6tmm2chFHj5GbR+fEa7PEo0HgjRPN7QHMC8FOA00cgXkahJgEj+mVh3Eb04NEEz8fUJ1eTn1SPEPWx6dPfmrQ+juLD2I/PE5kHTh2/jJNHz8IiTkuu2tFEooDU6odpAESnDRXFp7R1ZPRgbcmVznk0nwkf18ala/p9DzvudDB3GagVgU0DKQz15feOYHynDfunPvc9rmaQes3pfDq2xEvaJND4qxDl3w6w8ns+Cud8eFmZE2jpwVT9UjDajlnZUfD5uLJxaSVx24yJNBFzuyZJMQuX7B3AXKGEiXcuwq82QFgrRq8qOlr0G6MtF7pFNjTHWmhC1Sq5GhQMlKqjI1Ii4pdMjNW2CUF5oYniCsPoFqDmAt4iRSplJ261D24axnhWq5kN542sBm0J8N5gqP1ugKV/52HhaBNeMoTltu1BBBg1tXIn0PTvUc8BD3H9hRr8/oSaBtfroiq7eTGQ5MPPAycnzuL8yUk41BU0nfCKZpbqI6PtDk4lXaSldAgi97qtQGWyjxBCbv940JhQ4SKIw1i7LkQYjFK4DgWpUcyf8JEeBZIDQHEKYA7F7uye4VFsyRuqLk5FxgG3qlZbczayAlD/4xAL/9bD7OsNNBGKeX1bR2g3SbVZcjq2kU7cJ7J3PGLybTlVoPDjNse4AlHpJGlMkY/dwOUrK5h49wr8pif4VVsK6CqUI9kSUX0GDUCrBVf0X+xLIv9OhbJYtI22gOfn4kc7FoFrUYSlAMVlhoFhoF7jj2RhIDmQTyCdNUBbq5smlo5RkTIbAMEVhsVXm6iXfcCWXbmt+FuLbK6WttXmMaZdxNklHbjTSlXy8ZSfUfFKP0YFdjPNnGKnGSaOn8elyRnYttPqaiFa93sbQCV1gjuTdqRfMELWnvKAoBX5b8O4+oHa529353CJ452jpaUQmU0QXaFcQtNWOufCTbfq/WpC0u1pV+1D6xeapwtHauJ1V6mtrngPGSJWFdno6DJq/obWrZrBGL13oFt0g2nuwWmlKrcpVTncIeM4ruQkaOdOLuHs8Wmw0GupRe5wCfXIabkAypaVrO6FkSggRUGZpP/SB6Oik5RG+0POzySH8Mr9WasBU+Gz8YWxtrUU+/hALQSyW4BkjsIJk2lLjMG5Cpi17Bm5StJKJ+svTv2vZcaHrvbfQUFTinERFT0V+dKqpalTh9AmFmOGZWQdnGVi7KMfd0rFLjkpflxlAOvv5IkD3Zbz+IcWw8R7FzBzZR5yvLGtbJjSFiGHzIXFbNkNw+FhFLYAVI6t5tlWhErALEuCaUVqMaooRgUwTNkwRLZNZ5fEgm1ZoCGFXwrhgSF9G5AcIyCBfEVfDFDd7FtsoU0v/ObcD8tHCydqIHcy0FEiZ21TVBaqFUWhHQIDjLDDul7Z3Toso9s7qgLOB1WQWSfDcV0xeRmuOn5iDpMTM2IAhUWdVsvnUkP4y+p4agEkCbFhC6nj6iraj4NnKTVIVbTEanPk9mfkz0UmQvloTIVciAafeLQalbbudsDZB9gJ4dV2ymlbKxa0Wj1SkPfKE43vTn59SYzXytzsgiSpmlaPKGqr6HArFhRJonG6bl166CAx0IbT/kil2j0C4EFjdiDdN+MEaRfgN4DT70xhab4A2+K2jIPmglBbqDc+n754y6AAzFLp1FQ43EJtEhnRkFF7xS4h5xMUSeLEUiEvS4aOI3IDOQsaVQuJVGjI2m2ZD0TkczrlgTDP4Fuex+MtnYBYo6xWj5RPKhQE357/QentlaM1ZPcTuGOWHPZE20FSUV+sfVNXsUK9vegSFgdSnKqMBq//tWKWTwK4V5vxAErybOUiDAHHj1/B5fOzYh5BIWUyk0O+YFfZNCZICRWAURW84r9Hc+auBoy0KLwGj7SNHFzWniwyImhCC/HZfUK1LiYXlTawWZXTPYUNhibz6jJLsqfm3Bs9NLgAAA6lSURBVLVQeQR5r3qh+a2LX18A2cOQ2G3BSkRhGqgQDmv5KMwExLRfZmC3m+Drx7uqR+B7KjDNoya3aBLHlFN+A9CoAKdPXkK5WIEt1KItbBqXHJtwCXOE/eKREd6XJn00WyxUEQzacpCpAkSyS6ulKklrP1vlh0T7tsiImntQ+HmM8GiYkKfAD1Gf9xEsAv50gGqlVvLhma8/iQuTx9XYavUo/5Fm6LPvzr1afnP5UpUldlI4Q0raSJR5u7oxXCVxiJE4dJG6OFUZqu4dPiHL99X2T8khtq1ZFm6V398/NoO5C8tgvmJ7kfpTL13lADrEgS2AlFJoK1CjYDGN1F1IW2rQhlKJRDtnpEIF0ySt2T4FSGKxxBIEAHcTG14gUusqlxkWXgaWXwsxtXJ+ZhGz0TxCZvPu1Ixj96FZ9IEvOfSfsGZTf3zxD5eItTVAcp8NmpLHtGfVZqvPaJ7aVHumo9ztFvXzWaov7hX1pusnlC/3oExhqBYZTrw9icJiFZRLVKTmROjKFpLVhkDmtFMlZaQFhC0ZZajAAX8DqCQqgorwczFH7GMpVcpCqjFjCVwYEvhBCK8Zol4PUKv74rNRZ2iuAPOvBlh6p1454r86cRnnF2NCh50kriOI9tfxe2qd+Akv/b2nXn7uzV2fGj6Y3JGi1llLGHsxCbReuaFh00Ij4GuCt54SHe+pFAXui92nXkvOKT5jOP1nCyhMV2DbNizLVlqctlIBBDtUUX3Z98XgEOkGcEAFtJycWLb45FJlUaulXnnoi6tXDq5sRJLqM1EVSuJsuZ1rIxL1w4lQFhPBidChyPQ7KJ0sYaE8e+wsTpyqoaLzYZNr91zsP8R/bO2bQvbM4cJzX73yzcp/2vU5x03tsVFZAWiRXQUGMzeZJKRT0ffRGagpbUzN8xG9lutj6ucJgkKzjOwmG5nhLCxHtZZQARSqWIWamJ8FUr1bnOWJ3glXgUKF2uR+lXi/tu3AsROCVXJ1a1muyN+XLz63VJYxUcyTiBcKRX2I4nGs9szl3GWyEoBX8LBQWSn80P/O30xjalJ7WXMvOWcdy6quGRt28KPg+y+5Lz91fPzh9O3ZnRb1Jim8agjiyVpedQXTfKIDq4yzX3Hg6rn7PKviZpWiEAD+DFCbYZj5PyX45RDp4ZTo/7Jsu5X/IToviXRViCIJYRiFqSKa76iIBwfGAuWg8XkeLQfUkXZc7MdfY2KFyp7LGT0FIeO93ZTJrOImQ9AMEdRDeOUQQY0AngUaWEhVLCy+v1R6aeG73/hzfO2HM5iqquZngtVt/GssgFdVnYuk81XywhfvOnz77+z8lf4cmXJQ/mkIUmTC07eYTI/mi0NlR2hruK8+PMoEsdPV9VsPVAB4XKUl3ASUiz6m3p3F1MV5zF9awdT7V9CsBjLGxxkd74R0ZUULKeCV7VAJkiUZsHCV1QALy7XE7Kk8XGcJCZM3GKrG0goZh3L2ap6nL+h8wMA8Oe2S7zPZYcpnO2gwMF/MeQBKkxhgfeiv5eAtNZbebLz+rf+G//An85ieV7XkGaMS9KEj5hCSTkkY7KpOUALiHWNvvjD0yuhXRh5KHRzcZdPEZYImjxE22kiomYfaFa7bNxOsbpIV3Zqr4o6ccNwG1JIhZt9expGX38PbP3kdcwuTCNSL2dqBW9qqZLIqgKssHInig7QVFaHcjtnS4UYofSy0hjjJfS2l6ySD5BJrt75HdtSyLbgpF3YygWTGQdLKIBVk4S661YX5mbl3/SPf+Bp++4VlLBS0162b+dLdxsN2LCZopIEa+338xvzmxq7/vuOl8d/M/pozlNrjwpsH2CJr5RQxE5S40smZhnbbVA1F4gHjPUCzj2F2soQ3XjmBt15/DTNXJuCzpjoscnppy4fSt0mZstqdnizyx6hiiDwGKN9jwkhE86PAlTxeME3lbNtU2joOkO06cBIOklk+HiaBVC6JVDqJZCKDRNOBPxk25s8uLbxVfuPFV9gLL/8UP7jYRCOactSUIHPdHA9r1hbRuXhcugFtoB68g7/95s7XbvzHow/tPTRyq0vcbUS4hqzUnnE7RPsNFC3JgUE04ny4aL+06o7ZA4RDfF6POt5+8X0hWZcunEaDTzwskrUlFYfWA91ydIWEqEgIsRR8djtrquVzqT8SgasiIBHx4FLEPx2pQh3XlRKUTSGVSyCdSyKZScBNOnBTCeED+jMhSsdrjSsXFubP1069/Kr/4muv4sWzddSqTCpcGCDp6jCOjHQjJi261ilHhPw5/qCwxz/wRzf8YNuO7E57c2Z/AuVFAhald0dZ0ky99oPFAEQ6rLvK/9otafzSYoj3vnsKR378GibPT6BWLwijL2g3bKXiNAeXM8AotNRSa5G/FUmWjICIGKEC2IqSfCwZc+QSxImMk7CRSieQyCSR7HMFSKks/+7CtfgczhSsAgRzjHkrASsu1sNqYaVaqC8f/7v6T197Kfj2u1M4O19FqezD1+OL5ugFc3yQySR1CeuoIjuBRquo4G/wzT/d9NNtnxv7xP2bMw8A7laZzydeWBAYRwQGsYizZ456AflmuRQYcOpvz+GNV3+CcxOnsFJcQABfBXodFXKSTrEl1qO0AVdG67mUKBYkRmoy1cUiIvttxhgxRb44roVEJoFkzkGqLykWIUHUBWlQEZ0XU8RP8WcNUKrUazW/OlvxStMFb3l6wZubPuW/d+U9vDG7hIXlCorLRSxHU5lGuiUOoE6Laefi1GNPoIkbOIJXig82n/rG3Gt33JjeR7fnbk4imFdz3VexmoyYl9DVoK2c5GHZpVLxgRN/dxHvHn0b5ydOYWF2Gj6aAiiHZFUoSkoSFfke8ruQDhHVsFvqkaqOzhZp4FIkAKJwkly9cclxkMgmkUw5cEkStmeBNC2Rz4EFgrBMUWv6lZpXmil5pdmV5tLs5caF6RP+uzMTOLbcFK9T8GsemjW+XkahWkMlGgukdwXHARM3fL+Tn9aJiKz6HgdaS7k10XD+Al/7s+G3xj712Xef3t73hJS2ZvRShbix09FtWO0ZBQRYA0CjBhw7fhkT547jzPnTmJ+7gkazBgsJpGmmFdAV4LSAc1pdLUIZEhkBEZENKvvLHIfCSTlI5BJiCFPCdeAiATtwYPs2rKYNctmG1eATt3jFsleZLnkL80v1+bmL9fOzx4K352dxpeCjWfPglZuoV8oolpcxX/HQNN9dFUmUE2OvzOGSOp0PYwZ0BUbt9eRkrzVqhpzAO8vnahPfWXr9sX2ZO+mOvj0pBHMQg8NZuW3biM4GrXZOPWeGnENNnJ7HuXMTOHXhDOYXL6Neqwpgsk5exPdYFMglEgyrFbBVKs/iEQsKN+1KFpd2kbZSsJkLJ7Rh+w4cLwFn1hVzXHmsuVjzavMrzcX5+frcwtnqxPwp9u5KBZVlD41iA7VSFZVSAYvFOVypaNPD6D3HVEUxzErVh0iGhiSFBlCmDxbnh3VTi1eBZ4JmWiN+MvcVfOdbO4/uPvxLbz29o/+XGJytRPQT8bdIhA0tAmop51hNMetbwMXpAibOncXJs5OYW7gAr1kTKQBpOiBZnjhOsj7LUn6QY8NNuEjwxUkgwRLiHWZO6MBlCTiNJNyGmKqj7oXeYj2oLi3W55fm6jOLp+snVqZxqdhEfamB+koNlUIRK8szuFRYxnxZ0wN6Yo2tDUXSW7rfQXWZBCI0AGIxEtWJfHSLgqzbprWk7RjenH+39saLj7/25D3Lh2qb8nvTCBeVtC2rMyfVGyeG5Vmny2VMXLiME6fPY3r+PJrVqrhFF1kQWyZ+Oo70fRwrgSRfaBIOc+CELhJhGqlGSqg2hmDFD/3lWrOyMteYXp6qXVieDE4v11BdbqC+XEd1pYSVpUXMLk3idEHzj8wXKydjgDHVlFmB6wEtTup0dbmWU91TWVM9qpM5x/Cz73z/vRf3PPW9x77c96Vkn3sDRZ3TYE/2lTqDskoWvDIuXJrH+5NnMTlzTqhBmznoS+eRoNy/kVJjhzaSNIE0y8IJOBu0a8wLi17QLFQb1cKl+vmVqcZkcQVLXGIWa6guVFBYXML8wgWcXpjBpYq6P12lRUuU9aRXiB8DWKfWHbdPnDqLk5pOwHUCrFOK7rptmmkMrbfxo7mRxuY/OfTyw3fNDNYfzu924Gx24PCXzzX4wIcqiktlnLgwhanpy6gVqsg3h5Ak25BkKSQhpKgGRiosZGXPa5YLzZXyufqZagFLCx4aC3XU5yooza1gcf4CTs+cwtGCh6Y5O0AkOYmYig6MBLxOAPQC2lqSZoJmgtLpt7h76VTvsaVbvoKZ0oUDuNs5jOc/f3P2ln9y/7333DC2tX804VtiHuCJi3OYXpmFV6lXaYNWEdCq7/vVYrNQXfTnylWU55tozDVQm6+gPFfEytwUzs6+iyMLZRR8gwCsmUbW5cHigOkGWrf9om1xkQrTt4oDLe6z03328myrAIrbroOnt3Dvdtyz9XP4ynMukr+YQmYr53xVFIs+/JkmGjMN1OYqKE8vY2H2FI5OH8XPChUUg5jzbuTeOpW1VBxiAOkkYVjjmE5qM+57t+uhw7YNVUyctBmSQHgAyNmMbYkUss45nPB9mWEqAJZXbyXawQDsepZOD92LWsQ6tnVa78QAux3f6V57Kt0qsQfgWr+b03rq0mmea0M32qX0ClqnbYiJ+3X67FW1drput/vsufSiovR9aAxw5oh9EgNqL4UZ112rrGUH1gJqvepqLYnp9Bl3b5229VR6tSvE2NZJ8szFPLZb+aBBi9vWqwR0A2AjZOKatEwvldMJOHQBK27fbqXbQ8Qd32n/tVr0ekDrtG2jYFwvc9CzFJj7mUBuFKzrWXqpsOuhstba57qB06lspGI7SRzroEZ7eYj1+mOdEhg6ndvsU1+PpPZaPnCwonIt0tDNMb8e5++1XA/puN7HfaDlelXqz1sVXkv5SAKxnnJ9ZqFrl7VUWa/HXM/y/1KD6qlcy2z7vZb/7yrtQy0A/i8LtYlBnLXixQAAAABJRU5ErkJggg==" alt="coin image">
                +{{goodsDataItem.bonus}}&nbsp;
              </span>
              <span v-if="goodsDataItem.get_point > 0">
                <img src="@/assets/imagine/topup/point.png"/>
                +{{goodsDataItem.get_point}}
              </span>
            </div>
            <div class="goodsBtn"><div class="price onlyPrice" @click="payNow(goodsDataItem)"> USD {{goodsDataItem.price}} </div></div>
          </li>
        </ul> -->
        <ul class="goodsListNew">
          <li :class="['goodsItem', index===activeGoods?'selected':'']"
              v-for="(goodsDataItem, index) in amountList"
              @click="changeActiveItem(index)"
              @mouseleave="handleMouseLeavem(index)"
              v-show="!goodsDataItem.disabled"
              :key="index">
              <!-- 标签 -->
              <div v-if="goodsDataItem.goodCorner" class="goodsCorner">
                {{goodsDataItem.goodCorner}}
              </div>
              <!-- 倒计时 -->
              <div v-if="goodsDataItem?.countDown" class="goodsTime">
                <p>{{endListTime[index]}}</p>
              </div>

              <div class="goodsImg" :ref="`imgRef${index}`" @click="changeShowDetail(index)" @touchmove="handleMouseLeavem(index)">
                <div>
                  <img class="imgIcon" :src="goodsDataItem.goodCover" :alt="goodsDataItem.goodTitle">
                  <div class="pointsNumber" v-if="hasLimit(goodsDataItem)"><span v-if="goodsDataItem.goodlimited === 'Daily'">{{$t('center.Daily')}}:</span><span v-if="goodsDataItem.goodlimited === 'Weekly'">{{$t('center.Weekly')}}:</span><span v-if="goodsDataItem.goodlimited === 'Monthly'">{{$t('center.Monthly')}}:</span> {{ limitTxt(goodsDataItem) }}</div>
                </div>
               
                <div v-if="goodsDataItem.showDetail" class="overDiv">
                  <div class="overDivTitle">
                    {{$t('center.compare')}}：<label><span>{{goodsDataItem.goodCorner}}</span></label>
                  </div>
                  <div class="overDivContent">
                    <div class="overDivContentImg">
                      <div class="overDivContentImgDiv"
                          v-for="detailItemData in goodsDataItem.goodsTooltipDetail"
                          :key="detailItemData.cover">
                        <img :src="detailItemData.cover" alt="icon">
                        <span :style="productStyleItems(`${detailItemData.count}`.length)">{{detailItemData.count}}</span>
                      </div>
                      
                    </div>
                    <div v-if="goodsDataItem.get_point > 0" class="grayBorder"></div>
                    <div v-if="goodsDataItem.get_point > 0" class="overDivPoints">
                      {{ $t('center.AccumulatedPoints1') }}：
                      <div class="overDivPointsInner">
                        <img class="pointIcon" src="@/assets/imagine/topup/point.png"/>
                        ×{{goodsDataItem.get_point}}
                      </div>
                    </div>
                  </div>
                  <img src="data:image/webp;base64,UklGRuYAAABXRUJQVlA4WAoAAAAQAAAAIwAAEAAAQUxQSGgAAAABcEhbbyY9hCAEYRAGYRAGYRCKUIQaDMIgFCEIg7D/my8GETEBsJYbMB7FHcBmzeSrR0X4N/zW3c7vTbfx76Fq/N81jeylOElb5MJyeGTCUS6ZBe3+34G6/dPQj1+dQpvfplXg4+MyklZQOCBYAAAAEAQAnQEqJAARAD6NOpZIJ4jNUgAoBGJaQAAeh4P4VbfZHLPG29du8sAA/vqtBfATH+n88kAr307NK0J5H/FUFTkyzK///4VUBv//8Mbl/mt///CpAAAAAA==" alt="" class="overDivArrow">
                </div>
              </div>
              <div class="goodTitle">{{ goodsDataItem.goodTitle }}</div>
              <div class="goodsCenter">
                <div v-if="goodsDataItem.goodsPackDetail.length" class="goodsPack">
                  <div class="goodsPackDetail"
                      v-for="detailItemData in goodsDataItem.goodsPackDetail"
                      :key="detailItemData.cover">
                    <img :src="detailItemData.cover"
                        alt="icon"
                        width="28"
                        height="28"
                        @load="countItDown(index, goodsDataItem?.countDown)">
                    <span :style="productStyleItems(`${detailItemData.count}`.length)">{{detailItemData.count}}</span>
                  </div>
                </div>
                <div v-if="goodsDataItem.goodsPackDetail.length" class="grayBorder">
                </div>
                <div v-if="goodsDataItem.bonus || goodsDataItem.get_point" class="goodsText">
                  <span>{{ $t('center.bonus') }}:&nbsp;</span>
                  <span v-if="goodsDataItem.bonus">
                    <img width="28" height="28" src="@/assets/imagine/goods/diamond.png"/>
                    +{{goodsDataItem.bonus}}&nbsp;
                  </span>
                  <span v-if="goodsDataItem.get_point > 0">
                    <img width="28" height="28" src="@/assets/imagine/topup/point.png"/>
                    +{{goodsDataItem.get_point}}
                  </span>
                </div>
              </div>
             
              <div class="goodsBtn"  v-bind:class="{'goodsBtnt':buyable(goodsDataItem)}">
                <div class="price onlyPrice textShow1"  @click="payNow(goodsDataItem)">{{ goodsDataItem.currency?goodsDataItem.currency:"USD" }} {{ goodsDataItem.price }} </div>
              </div>
             
          </li>
        </ul>
      </div>
     
      <!--   描述区域   -->
      <div class="FAQ">
        <div class="instructions">
          <div class="contentTitle">{{ $t('center.about') }}</div>
          <ol class="instrList">
            <li class="instr">{{ $t('center.about1') }}</li>
            <li class="instr">{{ $t('center.about2') }}</li>
            <li class="instr">{{ $t('center.about3') }}</li>
            <li class="instr">{{ $t('center.about4') }}</li>
            <li class="instr">{{ $t('center.about5') }} <a :href="mailto" style="color: rgb(85, 123, 225);"> {{ email }} </a> {{ $t('center.about6') }}</li>
          </ol>
        </div>
      </div>
      <div id="dropin-container"></div><!--   paypal支付用   -->
  </div>
</template>

<script>
import { payWithURLXsolla } from '@/request/pay_xsolla';
import { payPalOrder } from "@/request/pay_paypal";
import { getOrderParamsAirwallex } from "@/request/pay_airwallex";
import { myCardOrder } from "@/request/pay_mycard"
import { getOrderParamsPayerMax, checkOrderResultPayerMax } from "@/request/pay_payermax";
import { redirectToCheckout, loadAirwallex } from 'airwallex-payment-elements';
import { openUrl } from "@/util/index";
// 导入 JSON 文件
import payMethodJSON from "@/assets/json/payMethod.json";
import basicJson from "@/config";
// import goodsListJSON from "@/assets/json/goodsList_test.json";
// import goodsListJSON from "@/assets/json/init_2.json";
// import introduceMsgList from "@/assets/json/description.json";


export default {
  name: "MainContent",
  data() {
    return {
      activeMethod: parseInt(localStorage.getItem("activeMethod")) || 0,     // 当前处于 active 状态的方法（默认第一个处于活跃状态）
      activeGoods: 0,     // 处于 active 状态的下标（默认第一个处于活跃状态）
      paymentMethod: {},   // 付款方式
      endListTime: {},    // 优惠倒计时结束时间列表
      payMethodJson: {},
      goodsListJSON: [],
      goodsData: {},
      nameIndex:0,
      amountList:[],
      timer: []
    }
  },
  props: {
    data:{
      type: Object,
      Required: true
    }
  },
  computed: {
    amountListName(){
      return ['center.dailyPack', 'center.dailyProgressionPack', 'center.diamond']
      // return ['center.welfare','center.dragon','center.fairy','center.diamond']
    },
    isSandbox(){
      const hash = window.location.hash; // 获取哈希部分
      return hash.includes('sandbox');
    },
    // 监听当前的登录状态
    isLogin() {
      return this.$store.state.isLogin;
    },
    appid(){
      return basicJson.appid;
    },

    email(){
      return basicJson.email;
    },

    mailto(){
      return 'mailto:' + basicJson.email;
    },

    // 切换语言格式的方法
    introduceMsgList() {
      // return introduceMsgList["introduceMsgList"];          
      return this.$i18n.messages[this.$i18n.locale].introduceMsgList;  // 切换不同语言
    },

    // 支付方法的列表
    payMethodData() {
      const handleBackJson = {}
      const payMethodData = payMethodJSON["data"];
      const countries = payMethodJSON["countries"];
      for (const country of Object.keys(countries)) {
        handleBackJson[country] = [];
        for (const payItemData of countries[country]) {
          const { cover, name, payment_method, enable } = payMethodData[payItemData];
          if (enable !== false){
            handleBackJson[country].push({
              "name": name,
              "payment_method": payment_method,
              "cover": require(`@/assets/imagine/topup/${cover}`),
            })
          }
        }
      }
      return handleBackJson;
    },
    country(){
      this.onCountryChanged();
      return this.data.country;
    },
    // amountList(){
    //   return this.onAmountList();
    // }
  },
  watch:{
    data: {
      handler(newValue, oldValue) {
        console.log(this.onAmountList())
        this.amountList = this.onAmountList();
      },
      deep: true
    },
    nameIndex:{
      handler(newValue, oldValue) {
        this.amountList = this.onAmountList();
      },
      deep: true
    }
  },
  mounted() {
    // 监听整个文档的点击事件
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    // 组件销毁前移除事件监听
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    hasLimit(good){
      let result= good.times != undefined && good.pay_times != undefined && good.times > 0
      return result;
    },
    limitTxt(good){
      return good.pay_times + "/" + good.times
    },
    buyable(good){
      let hasLimit = this.hasLimit(good);
      if(!hasLimit){
        return false
      }
      return good.pay_times >= good.times;
    },
    handleScroll(){
      this.amountList.forEach(item => {
        item.showDetail = false
      })
    },
    onCountryChanged(){
      if (!this.data.country){
        return;
      }
      this.payMethodJson = this.payMethodData[this.data.country];
      if (!this.payMethodJson){
        this.payMethodJson = this.payMethodData["EN"];
      }
      if (!this.payMethodJson[this.activeMethod]){
        this.activeMethod = 0;
      }
      this.paymentMethod = this.payMethodJson[this.activeMethod]['payment_method'];
    },
    onAmountList(){
      if (!this.data.goodsData){
        return;
      }
      // const Data = this.isSandbox ? this.data.goodsData[this.nameIndex] : this.data.goodsData
      const Data = this.data.goodsData[this.nameIndex]
      this.goodsListJSON = JSON.parse(JSON.stringify(Data))
      const handleBackGoods = [];
      for (const goodsItem of Data) {
        let goodsDetail = [];
        let goodsTooltipDetail = []

        const { item_sku, price, goodCover, currency, goodCorner, countDown, goodTitle, bonus, get_point, pay_times, goodlimited, times, goodsPackDetail } = goodsItem;
        // if (goodsPackDetail.length) {
        //   for (const goodsItemDetail of goodsPackDetail) {
        //     const { cover, count, id, type, price } = goodsItemDetail;
        //     if (type == 3) {
        //       continue;
        //     }
        //     goodsDetail.push({ count, id, type, price,
        //       // cover: require(`@/assets/imagine/topup_prop/${cover}`)
        //       cover: cover ? require(`@/assets/imagine/goods/${cover}`) : ''
        //     })
        //   }
        // }
  
        if (goodsPackDetail.length) {
          for (const goodsItemDetail of goodsPackDetail) {
            const { cover, count, id, type, price } = goodsItemDetail;
            console.log(cover);
            goodsTooltipDetail.push({ count, id, type, price,
              cover: cover ? require(`@/assets/imagine/goods/${cover}`) : ''
            })
          }
          goodsDetail = goodsTooltipDetail.filter(item => item.type !== '3');
        }
        let disabled = false;
        if (countDown){
          const timestamp = new Date(countDown).getTime() - new Date().getTime();   // 时间差
          if (timestamp <= 10) {
            disabled = true;
          }
        }
        handleBackGoods.push({ item_sku, price, currency, goodCorner, goodTitle, bonus, get_point, disabled, pay_times, goodlimited, times, countDown,
          goodCover: require(`@/assets/imagine/goods/${goodCover}`),
          goodsPackDetail: goodsDetail,
          goodsTooltipDetail:goodsTooltipDetail,
          showDetail:false
        });
      }
      return handleBackGoods;
    },
    saveOrder(order, paytype, appid, uid){
      localStorage.setItem("order", JSON.stringify({order, paytype, appid, uid}));
    },
    
    // 切换支付方式
    changeMethodToPay(index, paymentMethod) {
      this.activeMethod = index;
      localStorage.setItem("activeMethod", index);    // 存储当前的支付方式
      this.paymentMethod = paymentMethod;   // 支付方式
    },
    tabNameSelect(index){
      this.endListTime = {}
      this.timer.forEach(t => clearInterval(t)); // 清除所有定时器
      this.timer = []; // 重置定时器数组
      this.nameIndex = index
      this.activeGoods = 0
    },
    // 切换商品类型
    changeActiveItem(index) {
      this.activeGoods = index;
      
    },
    changeShowDetail(index){
      this.amountList[index].showDetail = true;
    },
    handleMouseLeavem(index){
      this.amountList[index].showDetail = false;
    },
    // 去除商品的 cover 值
    removeCover(goodsPackDetail) {
      const backData = [];
      for (const goodsItem of goodsPackDetail) {
        delete goodsItem["cover"];
        backData.push(goodsItem)
      }
      return backData;
    },

    // 开始支付
    payNow(goodsDataItem){
      if(this.buyable(goodsDataItem)){
          return;
      } 
      const goodsData = this.goodsListJSON;
      for (const goodsItem of goodsData) {
        if (goodsItem.item_sku === goodsDataItem.item_sku) {
          goodsDataItem = goodsItem;
          break;
        }
      }
   
      let { goodsPackDetail } = goodsDataItem;
      // goodsPackDetail = this.removeCover(goodsPackDetail);
      const goodsPrice = goodsDataItem.price;
      const itemSku = goodsDataItem.item_sku;
      if (!this.$store.state.isLogin) { return this.$store.commit("changeAlertMsg", "Please proceed with the payment after logging in and selecting the items."); }   // 如果没有登录，就要弹出提示内容

      const userMsg = this.$store.state.userMsg;    // 获取当前登录的用户信息
      const goodsMsg = {    // 商品信息
        itemSku: itemSku,
        goodsPrice: goodsPrice,
      }
      const paymentMethod = this.paymentMethod;
      if (!paymentMethod) { return this.$store.commit("changeAlertMsg", "The payment feature is still under development."); }
      const payMethod = paymentMethod["method"];
      // 选择支付方式
      this.$store.commit("isLoadCurrent", true);    // 开启加载动画
      if (payMethod === "xsolla") {
        this.payWithXsolla(userMsg, goodsMsg, paymentMethod, goodsPackDetail);
      } else if (payMethod === "paypal") {
        this.payWithPaypal(userMsg, goodsMsg, goodsPackDetail);
      } else if (payMethod === "airwallex") {
        this.payWithAirwallex(goodsPrice, userMsg, paymentMethod, itemSku, goodsPackDetail);
      } else if (payMethod === 'payermax'){
        this.payWithPayerMax(userMsg, paymentMethod, goodsPrice, itemSku, goodsPackDetail);
      } else if (payMethod === 'mycard'){
        this.payWithMyCard(userMsg, goodsMsg, goodsPackDetail);
      }
    },

    // 使用 paypal 支付(获取订单)
    payWithPaypal(userMsg, goodsMsg, goodsPackDetail) {
      const goodsHandleMsg = {
        price: goodsMsg["goodsPrice"],  // 商品价格
        itemSku: goodsMsg["itemSku"],   // 商品计费点
      }
      payPalOrder(goodsHandleMsg, userMsg.userId, goodsPackDetail, this.isSandbox, userMsg.appid, this.country).then(res => {
        this.$store.commit("isLoadCurrent", false);    // 关闭加载动画
        let { status, data } = res;

        if (!status) { return this.$store.commit(`changeAlertMsg`, `get user token is failure, wrong message is ${data}`); }

        const { links } = data;
        const url = links[1]["href"];
        // this.saveOrder(orderId, "paypal", userMsg.appid, userMsg.userId);
        openUrl(url, true);   // 跳转到付款链接
        this.$store.commit("isLoadCurrent", false);           // 关闭加载动画
      }).catch(e => {
        console.log(e);
        this.$store.commit("isLoadCurrent", false);    // 关闭加载动画
        this.$store.commit('changeAlertMsg', e.message?e.message:`Network error, please wait for a while and try again.`);
      })
    },

    // 使用 xsolla 付款
    payWithXsolla(userMsg, goodsMsg, paymentMethod, goodsPackDetail) {
      payWithURLXsolla(userMsg, goodsMsg, paymentMethod['id'], goodsPackDetail, this.isSandbox, userMsg.appid, this.country).then(res => {
        this.$store.commit("isLoadCurrent", false);    // 关闭加载动画
        const { status, data } = res;
        if (!status) { return this.$store.commit("changeAlertMsg", `${data}`); }   // 如果请求失败，就弹出提示内容
        const { url, orderId } = data;   // 付款界面的 URL 链接地址
        if (!url || !orderId) { return this.$store.commit("changeAlertMsg", "Network error, please try again."); }
        const ivyStrData = localStorage.getItem("ivyFortressBattleUserMsg");    // 如果能走到付款这一步，前面就要验证用户登录，也就是会存在基本信息
        const ivyData = JSON.parse(ivyStrData);   // 将其转化为 Object 格式
        ivyData["orderId"] = orderId;
        ivyData["goodsDetail"] = goodsPackDetail;
        localStorage.setItem("ivyFortressBattleUserMsg", JSON.stringify(ivyData));
        this.saveOrder(orderId, "xsolla", userMsg.appid, userMsg.userId);

        // 跳转到付款界面
        console.log(url, ivyData);
        openUrl(url, true);      // 付款页面使用本页面
        this.$store.commit("isLoadCurrent", false);           // 关闭加载动画
      })
    },

    payWithPayerMax(userMsg, paymentMethod, price, sku, goodsList){
      const uid = userMsg.userId;
      getOrderParamsPayerMax(price, paymentMethod['type'], paymentMethod['org'], uid, sku, this.isSandbox, userMsg.appid, this.country).then(res => {
        const { status, data } = res;
        if (!status) { 
          this.$store.commit("isLoadCurrent", false);           // 关闭加载动画
          return this.$store.commit("changeAlertMsg", `${data}`);
        } else {
          const { url } = data;
          if (url) {    // 如果存在 URL 参数
            const ivyData = {
              userId: uid,
              goodsList: goodsList
            };
            // this.saveOrder(orderId, "payermax", userMsg.appid, userMsg.userId);
            localStorage.setItem("ivyFortressBattleUserMsg", JSON.stringify(ivyData));
            openUrl(url, true);   // 跳转到付款链接(一定要使用 open 方法，否则不会在这个位置暂停)
            this.$store.commit("isLoadCurrent", false);           // 关闭加载动画
            return;
          } else {
            this.$store.commit("isLoadCurrent", false);           // 关闭加载动画
            return this.$store.commit("changeAlertMsg", 'redirect url is empty, try again later');
          }
        }
      }).catch(error => {
        console.log(error);
        this.$store.commit("isLoadCurrent", false);           // 关闭加载动画
      });
    },

    // 使用 airwallex 付款
    payWithAirwallex(goodsPrice, userMsg, paymentMethod, itemSku, goodsPackDetail) {
      const userId = userMsg["userId"];   // 用户 ID
      const payType = paymentMethod.type;     // 确认支付类型(银行卡、Google pay 或者 apple pay)
      // 如果支付类型是 apple，那么就需要设备本身是 IOS 系统才会发起支付请求
      if (payType === "applepay") {
        if (!/Safari/.test(navigator.userAgent) || !/Apple Computer/.test(navigator.vendor)) {
          this.$store.commit("isLoadCurrent", false);           // 关闭加载动画
          return this.$store.commit("changeAlertMsg", "The current browser cannot initiate Apple Pay. Please use Safari browser.");
        }
      }
      // 获取订单
      getOrderParamsAirwallex(goodsPrice, userId, itemSku, goodsPackDetail, payType, this.isSandbox, userMsg.appid, this.country).then(res => {
        const { status, data } = res;
        if (!status) { 
          this.$store.commit("isLoadCurrent", false);           // 关闭加载动画
          return this.$store.commit("changeAlertMsg", `${data}`); 
        }
        const { id, client_secret, url } = data;

        // 将订单 ID 存储在 local storage 中(如果是第三方支付)(因为订单完成之后的跳转界面，不含有订单 ID 的信息)
        if (payType) {
          const ivyObjData = JSON.parse(localStorage.getItem("ivyFortressBattleUserMsg"));
          ivyObjData["airwallexOrderId"] = id;
          localStorage.setItem("ivyFortressBattleUserMsg", JSON.stringify(ivyObjData));
        }

        // this.saveOrder(orderId, "airewallex", userMsg.appid, userMsg.userId);

        if (url) {    // 如果存在 URL 参数
          openUrl(url, true);   // 跳转到付款链接(一定要使用 open 方法，否则不会在这个位置暂停)
          this.$store.commit("isLoadCurrent", false);           // 关闭加载动画
          return;
        }
        if (!id || !client_secret) {   // 如果后端没有响应指定的内容，则直接结束跳转付款页面的进程
          this.$store.commit("isLoadCurrent", false);
          return this.$store.commit("changeAlertMsg", typeof data==="string"?data:"payment is fail, please try again!");
        }

        this.redirectHpp(id, client_secret, payType);            // 使用 SDK 跳转到指定页面(使用银行卡支付)
      }).catch(error => {
        console.log(error);
        this.$store.commit("isLoadCurrent", false);           // 关闭加载动画
      })
    },

    payWithMyCard(userMsg, goodsMsg, goodsPackDetail){
      const itemsku = goodsMsg["itemSku"];

      myCardOrder(itemsku, userMsg.userId, goodsPackDetail, this.isSandbox, userMsg.appid, this.country).then(res => {
        this.$store.commit("isLoadCurrent", false);    // 关闭加载动画
        console.log(res)
        let {TransactionUrl } = res;
      
        if(!TransactionUrl){
          return this.$store.commit(`changeAlertMsg`, `pay failed`);
        }
        // if (!status) { return this.$store.commit(`changeAlertMsg`, `get user token is failure, wrong message is ${data}`); }

        // const { links } = data;
        // const url = data["TransactionUrl"];
        // this.saveOrder(orderId, "mycard", userMsg.appid, userMsg.userId);
        openUrl(TransactionUrl, true);   // 跳转到付款链接
        this.$store.commit("isLoadCurrent", false);           // 关闭加载动画
      }).catch(e => {
        console.log(e);
        this.$store.commit("isLoadCurrent", false);    // 关闭加载动画
        this.$store.commit('changeAlertMsg', e.message?e.message:`Network error, please wait for a while and try again.`);
      })
    },

    // 打开付款界面
    async redirectHpp(intent_id, client_secret, payType) {
      const currency = 'USD';     // 结算货币类型      // const mode='payment';// Should be one of ['payment', 'recurring']
      const devEnvironment = this.isSandbox ? 'demo' : "prod";    // 当前开发模式   // 'staging | 'demo' | 'prod'
      const redirectHppForCheckout = () => {
        redirectToCheckout({
          env: devEnvironment,    // 'staging | 'demo' | 'prod'
          mode: 'payment',
          currency,
          intent_id, // 订单 ID
          client_secret, // 前端密钥
          methods:[payType],   // 付款方式(用银行卡支付)
          successUrl: basicJson.returnUrl,
          failUrl: basicJson.returnUrl,
          // successUrl: 'https://neverland.ivymobile.com/',             // Must be HTTPS sites
          // failUrl: 'https://neverland.ivymobile.com/',                // Must be HTTPS sites

          applePayRequestOptions: {
            buttonType: 'buy', // Indicate the type of button you want displayed on your payments form. Like 'buy'
            buttonColor: 'white-with-line', // Indicate the color of the button. Default value is 'black'
            countryCode: 'HK', // The merchant's two-letter ISO 3166 country code. Like 'HK'
            totalPriceLabel: basicJson.company // Provide a business name for the label field.
          },

          googlePayRequestOptions: {
            countryCode: "HK",
            merchantInfo: {
              merchantName: basicJson.company,
            },
            emailRequired: true,
            billingAddressRequired: true,
            buttonType: "book",
            buttonColor: "black",
            buttonSizeMode: "fill"
          },
        });
      };
      // loadAirwallex({ env: devEnvironment });   //步骤2：使用适当的生产环境和其他配置点击初始化 Airwallex 可以选择其他生产环境：'staging | 'demo' | 'prod'
      try {        // 步骤 3: 使用适当的生产环境和其他配置点击初始化 Airwallex
        await loadAirwallex({ env: devEnvironment });     // 可以选择其他生产环境：'staging | 'demo' | 'prod'
        redirectHppForCheckout();        // 步骤4: 将客户重定向至 Airwallex 结账页面
        this.$store.commit("isLoadCurrent", false);           // 关闭加载动画
      } catch (error) {
        this.$store.commit("isLoadCurrent", false);    // 关闭加载动画
        console.error(error);
      }
    },

    onCountDown(index, timer, endTime){
      const formattedEndTime = endTime.replace(/(\d{4})-(\d{1,2})-(\d{1,2})T/, (match, year, month, day) => {
          return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}T`;
      });
      const timestamp = new Date(formattedEndTime).getTime() - new Date().getTime();   // 时间差
        if (timestamp <= 0) {
          this.amountList[index].disabled = true;
          this.endListTime[index] = '00:00:00';
          return clearInterval(timer);
        }   // 如果时间戳间距为零，就清除定时器
        // 计算时间
        const hoursTime = Math.floor(timestamp/(1000*60*60));
        const minuteTime = Math.floor(timestamp/(1000*60)%60);
        const secondTime = Math.floor(timestamp/1000%60%60);
        this.endListTime[index] = `${hoursTime>=10?hoursTime:'0'+hoursTime}:${minuteTime>=10?minuteTime:'0'+minuteTime}:${secondTime>=10?secondTime:'0'+secondTime}`;
        // console.log(this.endListTime,'this.endListTime')
    },

    // 倒计时运行(index: 下标，endTime: 结束时间(形如：2024-5-12 23:23:59))
    countItDown(index, endTime) {
      if (!endTime) { return; }
      // let timer = null;  // 定时器
      const timer = setInterval(() => {
          this.onCountDown(index, timer, endTime);
      }, 1000);
      this.timer.push(timer)
      this.onCountDown(index, timer, endTime);
    },

    // 批量并特异化渲染商品小项中的文本样式
    productStyleItems(numLen) {
      if (numLen === 5) {
        return {
          "font-size": "10px",
          "right": "-21px",
          "margin-left":"10px",
        }
      } else if (numLen === 4) {
        return {
          "font-size": "11px",
          "right": "-18px",
          "margin-left":"10px",
        }
      }else if (numLen === 3) {
        return {
          "right": "-14px",
          "font-size": "11px",
          "margin-left":"10px",
        }
      }else {
        return {}
      }
    },
  },
}
</script>

<style scoped lang="scss">
    #main_content {
      .method {
        .contentTitle {
          color: #333;
          font-size: large;
          font-weight: 600;
          line-height: 1.2;
          margin-bottom: 15px;
          margin-top: 8px;
        }
        .methodList {
          display: grid;
          grid-template-columns: repeat(3, calc(33.33333% - 0.69rem));
          //grid-gap: 1.6rem 1.6rem;
          grid-gap: 1rem 1rem;
          .methodItem {
            display: flex;
            align-items: center;
            padding: 10px;
            // padding: 5px 15px;
            border-radius: .6rem;
            border: 1px solid #ddd;
            background: #fff;
            cursor: pointer;
            .methodImg {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 100px;
              height: 38px;
              img {
                width:100px;
                height:38px;
                object-fit: scale-down;
              }
            }
            .methodPay {
              margin-left: 1rem;
              font-size: 1rem;
              line-height: 1rem;
              font-weight: 400;
            }
          }
          .pay_method_active {
            border: 2px solid #557be1;
            padding: 9px;
          }
          .methodItem:hover {
            box-shadow: 0 4px 20px 0 rgba(0,0,0,.1);
          }
        }
      }

      .goods_type {
        .contentAmountTitle {
          color: #333;
          font-size: large;
          font-weight: 600;
          line-height: 1.2;
          margin-bottom: 15px;
          margin-top: 15px;
        }
        .goodsList {
          display: grid;
          grid-template-columns: repeat(4, calc(25% - 1.2rem));
          //grid-gap: 2.4rem 2.4rem;
          grid-gap: 1.6rem 1.6rem;
          .goodsItem {
            display: flex;
            flex-wrap: wrap;
            align-content: space-between;
            justify-content: center;
            padding: 24px 24px;
            border-radius: .5rem;
            border: 1px solid #eee;
            cursor: pointer;
            position: relative;
            overflow: hidden;
            .goodsCorner {
              position: absolute;
              top: 0;
              left: 0;
              z-index: 1;
              color: #fff;
              font-size: 14px;
              font-weight: 400;
              padding: 5px 12px;
              border-radius: 0 0 .5rem 0;
              background: #ffa947;
              .goodTitle {
                width: 100%;
                color: #333;
                font-size: 16px;
                font-weight: 600;
                //line-height: 2rem;
                text-align: center;
              }
              .goodTitle2 {
                position: absolute;
                bottom: -.3rem;
              }
            }
            .scaled-img {
              display: flex;
              width: 120px;
              height: 120px;
              object-fit: contain;
            }
            .goodsImage {
              display: flex;
              flex-flow: column nowrap;
              align-items: center;
              justify-content: center;
              margin-bottom: 12px;
              margin-top: 14px;
              position: relative;
            }
            .goodsImg {
              display: flex;
              flex-flow: column nowrap;
              align-items: center;
              justify-content: center;
              width: 100%;
              height: 12rem;
              max-width: 180px;
              max-height: 135px;
              //margin-bottom: 1.2rem;
              margin-bottom: 12px;
              margin-top: 14px;
              overflow: hidden;
              // img {
              //   // max-width: 120px;
              //   // max-height: 120px;
              //   width: 200px;
              //   height: 200px;
              //   max-width: 200px;
              //   max-height: 200px;
              //   object-fit: contain;
              //   // height: auto;
              // }
            }
            .goodsImg2 {
              position: relative;
              //height: 13rem;
            }
            .goodTitle {
              width: 100%;
              color: #333;
              font-size: 16px;
              font-weight: 600;
              //line-height: 2rem;
              text-align: center;
            }

            /* 内容详情 */
            .goodsPack {
              display: flex;
              flex-wrap: wrap;
              align-items: center;
              width: 100%;
              max-width: 150px;
              justify-content: center;
              margin-bottom: 10px;
              border-top: 1px solid #eee;
              padding-top: 4px;
              .goodsPackDetail {
                position: relative;
                margin: 0 16px 0 0;
                span {
                  color: #666;
                  font-family: Roboto;
                  font-size: 12px;
                  font-style: normal;
                  font-weight: 800;
                  position: absolute;
                  bottom: 1px;
                  right: -8px;
                }
              }
            }

            .goodsBtn {
              width: 100%;
              padding: 4px 12px;
              // background-color: #557be1;
              border-radius: 6px;
              text-align: center;
              cursor: pointer;
              //margin-top: 15px;
              .price {
                color: #fff;
                font-size: medium;
                font-weight: 600;
                line-height: 1.6rem;
              }
            }
            .goodsBtn:hover {
              background-color: #4869bf;
            }
          }
          .goodsItem:hover {
            box-shadow: 0 4px 20px 0 rgba(0,0,0,.1);
          }
          .goods_active_item {
            border: 2px solid #557be1;
            padding: 23px 23px;
          }
        }
        .preferenceStyle{
          grid-template-columns: repeat(2, calc(50% - 1.2rem));
          .goodsTime{
            position: absolute;
            top: 4px;
            right: 6px;
            width: 100px;
            text-align: right;
            color: #fff;
            font-size: 14px;
            z-index: 1;
            font-weight: 400;
          }
          .BtnName{
            width: 144px!important;
            margin-bottom: 12px;
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            border-radius: 8px;
            background: linear-gradient(180deg, #4d98ff, #395cfc);
            box-shadow: 0 3px 0 0 #2442a6, inset 0 3px 5px 0 #78b3f9, 0 1px 6px 0 rgba(90, 163, 255, .6);
          }
          .BtnName:hover {
              background: linear-gradient(180deg, #4d98ff, #4a6bff);
              box-shadow: 0 4px 0 0 #2442a6, inset 0 4px 7px 0 #98cbff, 0 1px 6px 0 rgba(90, 163, 255, .6);
          }
        }
      }

      .FAQ {
        .instructions {
          margin-bottom: 30px;
          .contentTitle {
            color: #333;
            font-size: large;
            font-weight: 600;
            line-height: 1.2;
            margin-bottom: 15px;
            margin-top: 15px;
          }
          .instr {
            color: #666;
            font-size: 15px;
            font-weight: 500;
            line-height: 22px;
          }
        }
      }
    }


    .goodsText {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      // margin-bottom: 9px;
      span {
        display: inline-flex;
        color: #ff6d3c;
        font-size: 14px;
        font-weight: 400;
        line-height: 1.2;
        align-items: center;
      }
      img {
        width: auto;
        height: 14px;
        // margin: 0 2px 0 4px;
      }
    }
    span.endShowTime {
      text-align: right;
      color: #ea0000;
      font-size: 14px;
      position: absolute;
      right: 13px;
      top: 10px;
    }
    .goods-img {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 269px;
        position: relative;
        img{
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          -o-object-fit: cover;
          object-fit: cover;
          border-radius: 8px;
        }
    }
  /*  适配移动端的样式    */
  @media screen and (max-width: 800px){
    p.methodPay {
      display: none;
    }
    .methodList {
      grid-template-columns: repeat(3, calc(33.33333% - 7px))!important;
      grid-gap: 10px 10px!important;
      .methodItem {
        padding: 4px 1px !important;
        justify-content: center;
        border-radius: 0.3rem!important;
        .methodImg {
          img {
            max-height: 38px;
            width: 90px !important;
          }
        }
      }
      .pay_method_active {
        padding: 3px 0px !important;
      }
    }

    .goodsList {
      grid-template-columns: repeat(2, calc(50% - .3rem)) !important;
      grid-gap: .6rem .6rem !important;
      .goodsItem {
        padding: 8px 6px!important;
        border-radius: 0.4rem !important;
        .goodsCorner {
          font-size: 12px !important;
          padding: 4px 8px !important;
          border-radius: 0 0 .4rem 0!important;
        }
        .goodsImg {
          margin-top: 0!important;
          margin-bottom: 0.6rem !important;
          height: 120px!important;
          img {
            max-width: 94px!important;
          }
          .goodTitle {
            font-size: 15px!important;
            line-height: 20px!important;
            height: 20px!important;
          }
        }
        .goodsPack {
          max-width: 100%!important;
        }
        .goodsBtn {
          padding: 2px 12px!important;
          margin-top: 1px!important;
        }
      }
      .goods_active_item {
        padding: 7px 5px !important;
      }
    }
    .preferenceStyle{
      grid-template-columns: repeat(1, calc(100% - .3rem)) !important;
      .goodsTime{
        top: 2px;
        font-size: 12px;
      }
      
    }
    .goods-img{
      height: 214px;
    }
    span.endShowTime[data-v-06196624] {
      text-align: right;
      color: #ea0000;
      font-size: 14px;
      position: absolute;
      right: 11px;
      top: 4px;
      z-index: 99;
    }
    // .BtnName{
    //   height: 38px;
    // }
  }
.tabAndPoint{
  position: relative;
  .SelectBundle{
    font-weight: 600;
    font-size: 16px;
    display: flex;
    justify-content: start;
    align-items: center;
    border-bottom: 1px solid #e4e4e4;
    padding-bottom: 16px;
    margin-bottom: 16px;
    overflow-x: scroll;
    white-space: nowrap;
    scrollbar-width: none;
    .item{
      margin-right: 12px;
      border-radius: 50px;
      border: 1px solid #eee;
      background: #f5f5f5;
      color: #8a8e97;
      padding: 0 24px;
      height: 40px;
      line-height: 40px;
      cursor: pointer;
      word-break: keep-all;
    }
    .itemActive {
        color: #fff;
        background-color: #557be1;
    }
  }
  @media screen and (max-width: 768px){
    .SelectBundle {
        font-size: 14px;
        .item {
            height: 28px;
            line-height: 28px;
            padding: 0 12px;
        }
    }
  }
}
.goodsListNew{
  display: grid;
  grid-template-columns: repeat(4, calc(25% - 1.5rem));
  grid-gap: 2rem 2rem;
  .goodsItem{
    display: flex;
    flex-wrap: wrap;
    align-content: space-between;
    justify-content: center;
    border-radius: 1.2rem;
    border: .1rem solid #eee;
    cursor: pointer;
    position: relative;
    flex-direction: column;
    .goodsTime{
      position: absolute;
      top: 4px;
      right: 6px;
      width: 100px;
      text-align: right;
      color: #fff;
      font-size: 14px;
      z-index: 1;
      font-weight: 400;
    }
    .goodsCorner{
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      color: #fff;
      font-size: 14px;
      font-weight: 500;
      line-height: 18px;
      padding: 5px 10px;
      border-radius: 10px 0;
      background: #ffae49;
    }
    .goodsImg{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      margin-bottom: 12px;
      padding-top: 66.66667%;
      position: relative;
      .imgIcon{
        border-radius: 1rem 1em 0 0;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        -o-object-fit: cover;
        object-fit: cover;
      }
      .pointsNumber {
        position: absolute;
        bottom: 0;
        right: 0;
        z-index: 1;
        color: #fff;
        font-size: 14px;
        font-weight: 400;
        line-height: 13px;
        padding: 3.5px 12px;
        border-radius: 8px 0 0 0;
        background: #ff6d3c;
      }
      .overDiv{
        position: absolute;
        bottom: 76%;
        left: 50%;
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .2);
        padding: 12px;
        background-color: #fff;
        z-index: 2;
        border-radius: 8px;
        transform: translateX(-50%);
        min-width: 200px;
        pointer-events: none;
        .overDivTitle {
            color: #666;
            font-size: 14px;
            font-weight: 500;
            margin-bottom: 12px;
            span {
                color: #ff6d3c;
                font-weight: 600;
            }
        }
        .overDivContent {
            border-radius: 8px;
            background: #f4f6ff;
            font-size: 14px;
            color: #666;
            font-weight: 500;
            padding-top: 12px;
            .overDivContentImg {
                padding: 0 12px 12px;
                display: grid;
                grid-template-columns: repeat(2, calc(55% - .6rem));
                grid-gap: 1.2rem 1.2rem;
                .overDivContentImgDiv {
                    display: flex;
                    align-items: center;
                    img{
                      width: 28px;
                      height: 28px;
                      position: relative;
                      border-radius: inherit;
                    }
                }
                
            }
            .grayBorder {
                margin: 0 10px 10px 10px;
                border-bottom: 1px dashed #c3c6d3;
            }
            .overDivPoints, .overDivPointsInner {
                display: flex;
                align-items: center;
            }
            .overDivPoints {
                justify-content: space-between;
                padding: 0 1.2rem 1.2rem;
                
            }
            .overDivPointsInner{
              .pointIcon{
                width: 14px;
                height: 14px;
                margin-right: 4px;
              }
            }
        }
        .overDivArrow {
            position: absolute;
            width: 24px;
            height: 10px;
            left: 50%;
            top: 99%;
            transform: translateX(-50%);
        }
      }
    }
    .goodTitle{
      width: 100%;
      color: #333;
      font-size: 16px;
      font-weight: 700;
      line-height: 16px;
      text-align: center;
    }
    .goodsCenter{
      border-radius: 8px;
      background: #f4f6ff;
      padding: 10px 12px;
      margin: 12px;
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .goodsPack {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        width: 100%;
        justify-content: space-around;
        padding: 0 5px;
        .goodsPackDetail{
          span{
            color: #666;
            font-size: 12px;
            font-style: normal;
            font-weight: 800;
            position: relative;
            left: -2px;
          }
        }
      }
      .grayBorder {
          margin: 10px 0;
          border-bottom: 1px dashed #c3c6d3;
      }
      .goodsText {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: center;
          span{
            color: #ff6d3c;
            font-size: 14px;
            font-weight: 500;
            line-height: 1.2;
            display: inline-flex;
            align-items: center;
          }
          img{
            width: auto;
            height: 14px;
          }
      }
      
    }
    .goodsBtn{
      padding: 10px 12px;
      background-color: #557be1;
      border-radius: .6rem;
      text-align: center;
      cursor: pointer;
      margin: 12px 12px 15px;
      position: relative;
      .onlyPrice {
          line-height: 28px;
      }
      .price {
          color: #fff;
          font-size: 16px;
          font-weight: 600;
      }
      .textShow1 {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          word-break: break-all;
      }
    }
    .goodsBtn:hover {
        background-color: #4869bf;
    }
    .goodsBtnt{
      padding: 10px 12px;
      background-color: gray;
      border-radius: .6rem;
      text-align: center;
      cursor: pointer;
      margin: 12px 12px 15px;
      position: relative;
      .onlyPrice {
          line-height: 28px;
      }
      .price {
          color: #fff;
          font-size: 16px;
          font-weight: 600;
      }
      .textShow1 {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          word-break: break-all;
      }
    }
    .goodsBtnt:hover {
        background-color: gray;
    }
 
  }
  .goodsItem:hover {
      box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .1);
      background: #fff;
  }
  .selected {
    border: 2px solid #557be1;
  }
  
}
@media screen and (max-width: 768px){
  .goodsListNew{
    grid-template-columns: repeat(2, calc(50% - .55rem));
    grid-gap: 1.1rem;
    .goodsItem{
      .goodsTime{
        top: 2px;
        font-size: 12px;
      }
      .goodsCorner{
        font-size: 12px;
        line-height: 14px;
        padding: 4px 8px;
      }
      .goodsImg{
        margin-bottom: 8px;
        .overDiv{
          min-width: 148px;
        }
      }
      .goodTitle{
        font-size:15px
      }
      .goodsCenter{
        padding: 8px;
        margin: 8px;
      }
      .goodsBtn{
        padding: 5px 12px;
        margin: 0 8px 10px;
        .price {
          font-size: 15px;
        }
      }
    }
    .selected {
      border: 2px solid #557be1;
    }
    
  }
}
</style>